import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { connect } from "react-redux";
import Stack from "@mui/material/Stack";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Radio, Paper } from "@mui/material";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { useMsal } from "@azure/msal-react";
import DPGroupedBarLineChart from "../DPGroupedBarLineChart";
import BarChart from "../BarChart";
import DPBarMultiple from "../DPBarMultiple";
import GraphService from "../../../../services/console_services/Graph";
import Loading from "../../Loading";
import { setModuleTabIndex } from "../../../../store/Actions";
import CustomScrollButton from "../../ReusableComponents/CustomTabScrollButton";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={1}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((_theme) => ({
  root: {
    flexGrow: 1,
    dispatch: "flex",
    padding: "10px",
  },
  paper: {
    boxShadow: "none !important",
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "58vh",
    width: "100%",
    position: "relative",
    top: 0,
    left: 0,
  },
  select: {
    borderColor: "transparent",
    borderStyle: "none",
    height: "30px",
    width: "120px",
    borderRadius: "4px !important",
    background: "var(--Neutral-Colors-White, #FFF)",
    fontSize: "14px !important",
    color: "#404041 !important",
    "&.MuiOutlinedInput-root": {
      margin: "0px 17px",
    },
  },
  main: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    padding: "0px 10px",
  },
  appBar: {
    padding: "10px",
  },
  tab: {
    background: "#FFF",
    boxShadow:
      "0px 2px 4px 0px rgba(0, 0, 0, 0.10), 0px 4px 12px 0px rgba(0, 0, 0, 0.10)",
    flex: 1,
    minHeight: "30px",
    borderRadius: "8px",
    // marginRight: "100px",
  },
  activeTabs: {
    color: "#FFF",
    textAlign: "center",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    fontWeight: "500",
    textTransform: "none",
    borderRight: "1px solid #92949747",
    minHeight: "30px",
    border: "1px solid var(--Neutral-Colors-Off-White, #E6E7E8)",
    background: "var(--Nestle_Blue, #0067A1)",
  },
  inActiveTabs: {
    color: "#59595A",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    textTransform: "none",
    minHeight: "30px",
    opacity: 1,
    border: "1px solid var(--Neutral-Colors-Off-White, #E6E7E8)",
    background: "var(--Neutral-Colors-White, #FFF)",
  },
  indicator: {
    display: "none",
  },
  filter: {
    fontSize: "14px",
    margin: "0px 2px",
  },
}));

const networkOptions = [
  { entity: "Network", value: "AMBIENT" },
  { entity: "Network", value: "CHILLED" },
  { entity: "Network", value: "FROZEN" },
  { entity: "Network", value: "NPW" },
];

const GraphView_ERM = ({
  tabIndex,
  Module,
  Network,
  DC,
  Products,
  Division,
  PL3,
  graphViewTabList,
  date,
  applyFilter,
  role,
  moduleTabIndexChange,
}) => {
  const classes = useStyles();
  //const networkOptions = ["AMBIENT", "CHILLED", "FROZEN", "NPW"];
  const allData = useSelector((state) => state);

  //const dcOptions = ["5722", "5222"];
  const { instance } = useMsal();
  // const [chartData, setChartData] = useState([]);
  const [topOrBottomValue, setTopOrBottomValue] = useState("Top");
  const [countValue, setCountValue] = useState("5");
  const tabValue = useSelector((state) => state?.tabs?.moduleTabIndex);
  // const [categoryList, setCategoryList] = useState("");
  const [graphDataIOF, setGraphDataIOF] = useState([]);
  const [loading, setLoading] = useState(true);
  const activeTab = graphViewTabList.filter(
    (item) => item.index === tabValue,
  )[0].name;
  const countList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const [updateThreshold, setUpdateThreshold] = useState(false);
  // const [entityName, setEntityName] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  // const [duration, setDuration] = useState(4);
  const duration = 4;
  // const [isPrevMonth, setIsPrevMonth] = useState(false);
  // const [metricName, setMetricName] = useState("Network");
  // const [metricOptions, setMetricOptions] = useState(networkOptions);
  // const [selectedMetricOption, setSelectedMetricOption] = useState("AMBIENT");
  // const [dollarValue, setDollarValue] = useState("Inv.On Hand Dollars");
  const [value, setValue] = React.useState([networkOptions[0]]);
  const entireState = useSelector((state) => state);

  const radioOptions = () => {
    if (activeTab === "Reason Code-Quantity Cuts") {
      return ["MaterialID", "CustomerName", "Business"];
    }
    if (activeTab === "Reason Code-Late Loads") {
      return ["CustomerName", "Business"];
    }
    if (activeTab === "Exceptions-Sales Doc") {
      return ["MaterialID", "CustomerName", "Business"];
    }
    if (activeTab === "Exception Monitoring") {
      return [
        "Network",
        "DC",
        "Division",
        "Supplier_Planner_Code",
        "Deployer_code",
      ];
    }
    return []; // Ensure it always returns an array
  };

  const [selectedRadioValue, setSelectedRadioValue] = useState(
    radioOptions().length > 0 ? radioOptions()[0] : "",
  );

  const getGraphData = (params) => {
    setLoading(true);
    GraphService.getGraph(params, instance)
      .then((data) => {
        if (data?.data) {
          setGraphDataIOF(Array.isArray(data?.data) ? data?.data : []);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .finally(() => {
        setLoading(false);
        setUpdateThreshold(false);
      });
  };

  const memoizedParams = useMemo(() => {
    let params = {
      section: Module,
      type: graphViewTabList[tabValue]?.value,
      name:
        selectedRadioValue === "Customer Group" ? "CL6" : selectedRadioValue,
      arrangements: topOrBottomValue,
      value: countValue,
      X_Axis:
        selectedRadioValue === "Customer Group" ? "CL6" : selectedRadioValue,
      Week_count: duration,
      start_Date: new Date(startDate).toLocaleDateString("en-CA"),
      //start_Date: "2024-12-01",
      end_Date: new Date(endDate).toLocaleDateString("en-CA"),
      filter: {
        startDate: date?.[0],
        endDate: date?.[1],
        ScenarioName:
          entireState?.filter?.scenarioValue === ""
            ? []
            : [entireState?.filter?.scenarioValue],
      },
    };
    return params;
  }, [
    Module,
    tabValue,
    selectedRadioValue,
    topOrBottomValue,
    countValue,
    role,
    DC,
    Network,
    PL3,
    Division,
    Products,
    date,
    startDate,
    endDate,
    duration,
    updateThreshold,
    // entityName,
    // isPrevMonth,
    // metricName,
    // selectedMetricOption,
    // dollarValue,
    value,
    entireState?.filter?.scenarioValue,
  ]);

  useEffect(() => {
    // Conditional check to avoid unnecessary API calls
    // if (!memoizedParams.section || !memoizedParams.type || !memoizedParams.name || !memoizedParams.filter.startDate || !memoizedParams.filter.endDate) {
    //     return;
    // }
    if (
      !memoizedParams.section ||
      !memoizedParams.type ||
      !memoizedParams.name
    ) {
      return;
    }
    getGraphData(memoizedParams);
  }, [memoizedParams, applyFilter]);

  useEffect(() => {
    if (allData.filter.Network?.length > 0) {
      let data = [];

      allData?.filter.Network?.forEach((item) => {
        data.push({ entity: "Network", value: item });
      });
      setValue([...data]);
    }
  }, []);

  useEffect(() => {
    const today = dayjs(); // Get today's date as a Dayjs object
    setStartDate(today);

    const nextMonth = today.add(1, "month"); // Add one month to today's date
    setEndDate(nextMonth);
  }, []);

  const handleChange = (_event, newValue) => {
    moduleTabIndexChange(newValue);
    setSelectedRadioValue(
      newValue === 1
        ? "CustomerName"
        : newValue === 3
          ? "Network"
          : "MaterialID",
    );
    setTopOrBottomValue("Top");
    setCountValue("5");
  };
  const handleRadioChange = (selectedFilter) => {
    setSelectedRadioValue(selectedFilter);
  };

  const handleTopBottomChange = (event) => {
    setTopOrBottomValue(event.target.value);
  };

  const handleCountChange = (event) => {
    setCountValue(event.target.value);
  };

  const renderChart = () => {
    return (
      <DPGroupedBarLineChart graphData={graphDataIOF} activeTab={activeTab} />
    );
  };

  return (
    <Paper elevation={0} className={classes.paper}>
      {loading ? (
        <div className={classes.loader}>
          <Loading />
        </div>
      ) : (
        <>
          {/* <div className={classes.main}>
            <div className={classes.appBar}> */}
          <Box
            sx={{
              maxWidth: "70vw",
              overflow: "hidden",
            }}
          >
            <Tabs
              value={tabValue}
              onChange={handleChange}
              className={classes.tab}
              aria-label="simple tabs example"
              variant="scrollable"
              scrollButtons="auto"
              ScrollButtonComponent={CustomScrollButton}
              classes={{ indicator: classes.indicator }}
            >
              {graphViewTabList.map((item, index) => (
                <Tab
                  key={index}
                  className={
                    tabValue === index
                      ? classes.activeTabs
                      : classes.inActiveTabs
                  }
                  label={item.name}
                  style={{
                    minHeight: "35px",
                  }}
                  {...a11yProps(index)}
                />
              ))}
            </Tabs>
          </Box>
          {/* </div>
          </div> */}
          {graphViewTabList.map((_item, index) => (
            <TabPanel key={index} value={tabIndex} index={index}>
              <Stack
                direction="row"
                alignItems="center"
                sx={{ padding: "22px 8px" }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      rowGap: "10px",
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <Select
                        value={topOrBottomValue}
                        onChange={handleTopBottomChange}
                        className={classes.select}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        sx={classes.select}
                      >
                        <MenuItem value="Top">Top</MenuItem>
                        <MenuItem value={"Bottom"}>Bottom</MenuItem>
                      </Select>
                      <Select
                        value={countValue}
                        onChange={handleCountChange}
                        className={classes.select}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        sx={classes.select}
                      >
                        {countList.map((item, _index) => (
                          <MenuItem key={item} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                    <div style={{ marginLeft: "10px" }}>
                      {radioOptions().map((option) => (
                        <React.Fragment key={option}>
                          <Radio
                            value={option}
                            checked={selectedRadioValue === option}
                            onChange={() => handleRadioChange(option)}
                            size="small"
                            inputProps={{ "aria-label": option }}
                            sx={{
                              color: "#359DD0 !important",
                              "&.Mui-checked": {
                                color: "#359DD0 !important",
                              },
                            }}
                          />
                          <span
                            className={classes.filter}
                            style={{
                              color:
                                selectedRadioValue ===
                                (Module === "SNO" ? "Overall" : "Network")
                                  ? "#359DD0"
                                  : "#359DD0",
                            }}
                          >
                            {option === "Supplier_Planner_Code"
                              ? "Supplier Planner Code"
                              : option === "Deployer_code"
                                ? "Deployer code"
                                : option}
                          </span>
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                </div>
              </Stack>
              {renderChart()}
            </TabPanel>
          ))}
        </>
      )}
    </Paper>
  );
};

GraphView_ERM.propTypes = {
  tabIndex: PropTypes.number.isRequired,
  tabChange: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  tabIndex: state.tabs.index,
  Network: state.filter.Network,
  DC: state.filter.DC,
  Products: state.filter.Products,
  PL3: state.filter.PL3,
  date: state.filter.Date,
  Division: state.filter.Division,
  applyFilter: state.filter.applyFilter,
  role: state.login.role,
});

const mapDispatchToProps = (dispatch) => ({
  tabChange: (newValue) => dispatch({ type: "TAB_INDEX", payload: newValue }),
  moduleTabIndexChange: (newValue) =>
    dispatch({ type: "MODULE_TAB_INDEX", payload: newValue }),
});

export default connect(mapStateToProps, mapDispatchToProps)(GraphView_ERM);
